import { TAGS } from "../constants";
import {
  ClinicalNotes,
  CreateClinicalNotes,
  NoteTypeEnums,
  UpdateClinicalNotes,
} from "../types";
import { api } from "./api";

export const clinicalNotesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // clinical notes
    getPatientClinicalNotes: builder.query<
      ClinicalNotes[],
      { patientId: number; noteType: NoteTypeEnums }
    >({
      query: ({ patientId, noteType }) => ({
        method: "GET",
        url: `/api/clinical-notes/${noteType}/patient/${patientId}`,
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAGS.CLINICAL_NOTES, id: args.patientId },
      ],
    }),
    createClinicalNote: builder.mutation<ClinicalNotes, CreateClinicalNotes>({
      query: (body) => ({
        method: "POST",
        url: "/api/clinical-notes",
        body,
      }),
      invalidatesTags: [TAGS.CLINICAL_NOTES],
    }),
    generateNotePdf: builder.mutation<Blob, string>({
      query: (note: string) => ({
        method: "POST",
        url: `/api/clinical-notes/pdf`,
        body: {
          note,
        },
        responseHandler: async (response) => response.blob(),
      }),
    }),
    updateClinicalNote: builder.mutation<
      ClinicalNotes,
      { id: number; body: UpdateClinicalNotes }
    >({
      query: ({ id, body }) => ({
        method: "PUT",
        url: `/api/clinical-notes/${id}`,
        body,
      }),
      invalidatesTags: [TAGS.CLINICAL_NOTES],
    }),
  }),
});

export const {
  useGetPatientClinicalNotesQuery,
  useCreateClinicalNoteMutation,
  useGenerateNotePdfMutation,
  useUpdateClinicalNoteMutation,
} = clinicalNotesApi;
